import d from "lodash";
import i from "classnames";
import a from "react";
import { u as l } from "./utils-C0l876fA.es.js";
import './DotBounceLoading.css';const m = "#fff", _ = "DotBounceLoading-module__dot___0Xwc4", t = {
  white: m,
  "dot-bounce-container": "DotBounceLoading-module__dot-bounce-container___eRfAf",
  dot: _,
  "single-color": "DotBounceLoading-module__single-color___ZIP33",
  "hidden-span": "DotBounceLoading-module__hidden-span___zFFWo"
}, u = ({
  width: o,
  singleColor: n,
  color: s,
  delay: r
}) => {
  const c = {
    [t.dot]: !0,
    [t["single-color"]]: n
  }, e = {
    animationDelay: r,
    borderRadius: o,
    borderWidth: o,
    marginLeft: o * 3 / 2,
    marginRight: o * 3 / 2
  };
  return n && (e.borderColor = s), /* @__PURE__ */ a.createElement("div", { className: i(c), style: e });
}, b = ({
  singleColor: o = !1,
  width: n = 10,
  color: s = t.white,
  role: r = "status"
}) => {
  const { t: c } = l();
  return /* @__PURE__ */ a.createElement("div", { className: t["dot-bounce-container"] }, d.range(3).map((e) => /* @__PURE__ */ a.createElement(
    u,
    {
      key: e,
      delay: `${250 * e}ms`,
      color: s,
      singleColor: o,
      width: n
    }
  )), /* @__PURE__ */ a.createElement("span", { role: r, className: t["hidden-span"] }, c("loading")));
};
export {
  b as D
};
